var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":"#","title":"Supprimer ce point"},on:{"click":function($event){return _vm.showConfirmationModal()}}},[_c('i',{staticClass:"fas fa-fw fa-trash-alt text-danger"})])
}
var staticRenderFns = []

export { render, staticRenderFns }